import { makePaymentAccountingErrorElem, makePaymentPaymentErrorElem } from './constants'

export default function paymentDashboardErrors (accountingErrors = [], paymentErrors = []) {
  let errorsList = function (errors) {
    return errors.map((err) => {
      return `<li>${err}</li>`
    }).join('')
  }

  if (accountingErrors.length > 0) {
    const accountingErrorsList = errorsList(accountingErrors)

    makePaymentAccountingErrorElem.append(`<br/><ul>${accountingErrorsList}</ul>`)
    makePaymentAccountingErrorElem.removeClass('hide')
  }

  if (paymentErrors.length > 0) {
    const paymentErrorsList = errorsList(paymentErrors)

    makePaymentPaymentErrorElem.html(`There seems to be a problem getting the payment link: <br/><ul>${paymentErrorsList}</ul>`)
    makePaymentPaymentErrorElem.removeClass('hide')
  }
}
